// These three things match Spring Security's CsrfFilter and CookieCsrfTokenRepository.
const CSRF_IGNORE_METHODS = ["GET", "HEAD", "TRACE", "OPTIONS"];
const CSRF_HEADER_NAME = "X-XSRF-TOKEN";

export const CSRF_COOKIE_NAME = "XSRF-TOKEN";
export const CSRF_COOKIE_NONBROWSER = "non-browser";

// NOTE in a browser, document will be an object-or-string (probably an object).
// In node-based tests, document will be undefined.
// Some code written by other people also relies on undefined-document to indicate non-browser
//    e.g. node_modules/sinon/lib/sinon/util/core/deep-equal.js:3
export const inBrowser = () => typeof document !== "undefined";

export const getRequestWithTokenInformation = (method, headers, body) => {
  const shouldIncludeCSRF = !CSRF_IGNORE_METHODS.includes(method);

  let csrfToken;
  if (shouldIncludeCSRF) {
    if (inBrowser()) {
      const cookie = document.cookie.split("; ").find((row) => row.startsWith(CSRF_COOKIE_NAME + "="));
      csrfToken = cookie ? cookie.split("=")[1] : null;
    } else {
      csrfToken = CSRF_COOKIE_NONBROWSER;
    }
  }

  if (csrfToken) {
    headers = headers ? new Headers(headers) : new Headers();
    headers.append(CSRF_HEADER_NAME, csrfToken);
  }

  return {
    method,
    headers,
    body,
    mode: "cors",
    credentials: "include",
    cache: "default",
    redirect: "follow",
  };
};

const getServiceEndpoint = () =>
  undefined !== window.ecommerce && undefined !== window.ecommerce.serviceEndpoint
    ? window.ecommerce.serviceEndpoint
    : window.location.href;

// NOTE global.cpqUrl is used during "npm run test:services" which has no document.
// Even if there is a document, it's better to rely on window.location than document.location.
export const getBaseUrl = () => new URL("/", inBrowser() ? getServiceEndpoint() : process.env.REACT_APP_ECOMMERCE_SHOP);
